import { isWeb } from 'renative';

const contentTypes = {
    LIVE: 'live',
    VOD: 'vod',
    ARCHIVE: 'archive',
    PVR: 'pvr'
};

const fileExtensions = {
    MPD: '.mpd',
    M3U8: '.m3u8',
    UNKNOWN: undefined
};

export const getContentType = (mediaType) => {
    switch (mediaType) {
        case 'VOD':
            return contentTypes.VOD;
        case 'LIVE':
            return contentTypes.LIVE;
        case 'TIMESHIFT':
            return contentTypes.ARCHIVE;
        default:
            return contentTypes.PVR;
    }
};

export const getSubType = (mediaType, item) => {
    if (item) {
        if (mediaType === 'VOD' && typeof item.getRawData === 'function') {
            return item.getRawData().categories[0]?.type;
        }
        return item.getChannelId();
    }

    return '';
};

export const getMediaType = (streamUrl) => {
    let extension = fileExtensions.UNKNOWN;

    // Do the extension check only on mobiles.
    if (isWeb()) return extension;

    const hasMPDExtension = streamUrl.includes(fileExtensions.MPD);
    const hasM3U8Extension = streamUrl.includes(fileExtensions.M3U8);

    if (hasMPDExtension) extension = 'application/dash+xml';
    if (hasM3U8Extension) extension = 'application/vnd.apple.mpegurl';
    if (hasMPDExtension && hasM3U8Extension) extension = fileExtensions.UNKNOWN;

    return extension;
};
